import {gql, useMutation} from '@apollo/client'
import {useCallback} from 'react'
import {useAlert} from 'react-alert'
import {getUserDataQuery} from '../Users'
import {
    UseResendMutation_InviteUsers,
    UseResendMutation_InviteUsersVariables,
} from './__types__/UseResendMutation_InviteUsers'

export const USER_INVITE_DATA = gql`
    fragment UserInviteData on OrganisationObject {
        idStr
        users {
            idStr
            inviteStatus
        }
    }
`

const INVITE_USERS_MUTATION = gql`
    mutation UseResendMutation_InviteUsers($organisationIdStr: String!, $userIdStrs: [String!]!) {
        inviteUsers(organisationIdStr: $organisationIdStr, userIdStrs: $userIdStrs) {
            idStr
        }
    }
`

export function useInviteUsersMutation() {
    const {success, error} = useAlert()

    const [inviteUsersMutation, inviteUsersState] = useMutation<
        UseResendMutation_InviteUsers,
        UseResendMutation_InviteUsersVariables
    >(INVITE_USERS_MUTATION, {
        onCompleted: () => success(`Welcome email batch completed`),
        onError: () => error('Failed to invite users'),
    })

    const inviteUsers = useCallback(
        async (variables: UseResendMutation_InviteUsersVariables) => {
            await inviteUsersMutation({
                variables,
                refetchQueries: [getUserDataQuery(variables.organisationIdStr)],
                awaitRefetchQueries: true,
            })
        },
        [inviteUsersMutation],
    )

    return {
        inviteUsers,
        inviteUsersState,
    }
}
